import {
  actions,
  btag,
  Bus,
  constants,
  fetchGeoInfo,
  getBrowser,
  getOS,
  NotificationManager,
  pushToDataLayer,
  SettingsManager,
  SiteConfigManager,
  StorageManager,
} from '@atlas/core';
import { paymentRoutes } from '@atlas/routing';

import { QUICK_DEPOSIT_DELAY } from 'components/Casino/MainCasinoPage/MainCasinoPage';

import { get1X2Outcomes } from '../common/utils';

const {
  SPORT_SERVICE: { LIVE },
} = constants;

const DEPOSIT_FAILED_NOTIFICATION_BLACKLIST_ROUTES = [
  paymentRoutes.deposit,
  paymentRoutes.withdrawal,
  paymentRoutes.transactionHistory,
];

Bus.on(Bus.events.auth.login, ({ client }) => {
  pushToDataLayer('sign_in', { client: { id: client.id } }, btag);
});

Bus.on(Bus.events.auth.formRegistrationSuccess, profile => {
  fetchGeoInfo().then(response => {
    pushToDataLayer(
      'registration_completed',
      {
        OS: getOS(),
        browser: getBrowser(),
        created_at: Date.now(),
        device: constants.DEVICE_TYPES.DESKTOP,
        ip: response.ip,
        locale: response.locale,
        page_referer: window.location.pathname,
        user_id: profile.clientId,
      },
      btag,
    );
  });
});

Bus.on(Bus.events.bet.placedSuccess, ({ data }) => {
  const betData = data.bets[0]?.betMoney;
  const { betAmount, currency } = betData;
  pushToDataLayer(
    'bet',
    { client: { id: data.clientId } },
    {
      amount: betAmount,
      betInfo: data,
      currency,
    },
    btag,
  );
});

Bus.on(Bus.events.profile.depositComplete, ({ data }) => {
  const { amount, clientId, createdAt, currency, isFirstDeposit, paymentMethod, paymentMethodId } =
    data;
  const eventName = isFirstDeposit ? 'first_deposit' : 'deposit';

  pushToDataLayer(
    eventName,
    { client: { id: clientId } },
    {
      amount,
      created_at: createdAt,
      currency,
      payment_method: paymentMethod,
    },
    btag,
  );

  const showSuccessNotification = SiteConfigManager.getConfig(
    'config.config.accountProfile.showDepositSuccessNotification',
    true,
  );

  StorageManager.removeItem(QUICK_DEPOSIT_DELAY);

  if (!showSuccessNotification) return;

  NotificationManager.toast({
    data: {
      amount,
      currency,
      paymentMethodId,
    },
    id: 'depositSuccess',
    type: 'depositSuccess',
  });
});

let isDepositFailedHandledByForm = false;

Bus.on('ui:depositErrorHandled', () => {
  isDepositFailedHandledByForm = true;
});

Bus.on(Bus.events.profile.depositFailed, () => {
  if (isDepositFailedHandledByForm) {
    isDepositFailedHandledByForm = false;

    return;
  }

  NotificationManager.notify({
    id: 'depositFailed',
    message: 'transaction_failed_notification',
    routesToAvoid: DEPOSIT_FAILED_NOTIFICATION_BLACKLIST_ROUTES,
    status: 'error',
    type: 'notification',
  });
});

Bus.on(Bus.events.profile.paymentCreated, ({ data }) => {
  const { amount, clientId, createdAt, currency, operationType, paymentMethod } = data;

  if (operationType === constants.PAYMENT_OPERATION.WITHDRAWAL) {
    pushToDataLayer(
      'withdrawal_created',
      { client: { id: clientId } },
      {
        amount,
        created_at: createdAt,
        currency,
        payment_method: paymentMethod,
      },
      btag,
    );
  }
});

Bus.on(Bus.events.profile.withdrawalComplete, ({ data }) => {
  const { amount, clientId, createdAt, currency, paymentMethod } = data;

  pushToDataLayer(
    'withdrawal_completed',
    { client: { id: clientId } },
    {
      amount,
      created_at: createdAt,
      currency,
      payment_method: paymentMethod,
    },
    btag,
  );
});

Bus.on('betslip:main', action => {
  if (action.type === actions.BETSLIP_ADD_BET || action.type === actions.BETSLIP_SELECT_BET) {
    try {
      const { event, marketId, marketTypeId, outcomeId } = action.payload;
      const { lang } = SettingsManager.settings;
      const eventOutcomes = event.marketTypes[marketTypeId]?.markets[marketId]?.outcomes;
      const outcomes = get1X2Outcomes(eventOutcomes ? Object.values(eventOutcomes) : []);

      pushToDataLayer(
        'betslip_add_outcome',
        {
          id: event.id,
          language: lang,
          marketId,
          marketTypeId,
          outcomeId,
          outcomes,
          participants: event.participants,
          sportId: event.sportId,
          sportName: event.sportName,
          startTime: new Date(event.startTime).toISOString(),
          status: event.sportService === LIVE ? 'live' : 'not_started',
          tournamentId: event.tournamentId,
          tournamentName: event.tournamentName,
        },
        btag,
      );
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }
});
